import { DBObject } from './db-object.js';
export class DBIndex extends DBObject {
    name;
    table;
    column;
    unique;
    primary;
    spatial;
    constructor(options) {
        super();
        if (!options.table) {
            throw new Error("DBIndex: 'table' is required");
        }
        if (!options.column) {
            throw new Error("DBIndex: 'column' is required");
        }
        this.table = options.table;
        this.column = options.column;
        this.unique = options.unique ?? false;
        this.primary = options.primary ?? false;
        this.spatial = options.spatial ?? false;
        if (options.name) {
            this.name = options.name;
        }
        else {
            if (this.primary) {
                this.name = `pk_${this.table}_${this.column.split(', ').join('_')}`;
            }
            else {
                this.name = `idx_${this.table}_${this.column.split(', ').join('_')}`;
            }
        }
    }
}
